module.exports = __webpack_public_path__ + "img/part1.d50c5eef.png";